import * as React from "react";
import { Modal, Button } from "@grandvisionhq/common";
const InfoModal = ({ isOpen, onModalClose, title, message, okLabel }) => {
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen,
      onModalClose,
      title,
      showIcon: true,
      footer: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, { caption: okLabel, onClick: onModalClose }))
    },
    /* @__PURE__ */ React.createElement("div", { style: { margin: "1rem 0" } }, message)
  );
};
export {
  InfoModal,
  InfoModal as default
};
//# sourceMappingURL=InfoModal.js.map
